<ng-template viewModeHost></ng-template>
